import { gql } from 'apollo-angular';
import { TimeEntryCategory } from '../../shared/entities/timeEntryCategory/timeEntryCategory';


export const TIME_ENTRY_CATEGORY_QUERY = gql`
query getTimeEntryCategory(
  $id: UUID
)
{
  timeEntryCategory: getTimeEntryCategory(
    id: $id
  )
  {
    id
    name
    externalId
    enabled
  }
}
`;

export interface TimeEntryCategoryQueryResponse {
  timeEntryCategory: TimeEntryCategory;
  loading: boolean;
}
